import React from "react";
import { Link } from "react-router-dom";
import sidebarHelper from "../../../helpers/sidebar";

function FinanceMenu({ openItem, activeItem }) {
  return (
    <>
      <li
        className={`nav-item has-treeview 
            ${sidebarHelper.checkOpenItem(openItem, "all-finance")} `}
      >
        <a
          href="# "
          className={`nav-link  
            ${sidebarHelper.checkActiveItem(openItem, "all-finance")} `}
        >
          <i className="nav-icon hl-money align-middle"></i>
          <p>
            مالی
            <i className="right fa fa-angle-left"></i>
          </p>
        </a>

        <ul className="nav nav-treeview">
          <li className="nav-item">
            <Link
              to="/finance/charge"
              className={`nav-link  
                ${sidebarHelper.checkActiveItem(
                  activeItem,
                  "charge-finance"
                )} `}
            >
              <i className="hl-monies nav-icon"></i>
              <p>افزایش اعتبار</p>
            </Link>
          </li>

          <li className="nav-item">
            <Link
              to="/finance/pledge"
              className={`nav-link  
                ${sidebarHelper.checkActiveItem(activeItem, "all-pledge")} `}
            >
              <i class="hl-money-down-arrows nav-icon"></i>
              <p>لیست بیعانه</p>
            </Link>
          </li>

          <li className="nav-item">
            <Link
              to="/finance/invoices"
              className={`nav-link  
                ${sidebarHelper.checkActiveItem(
                  activeItem,
                  "invoices-finance"
                )} `}
            >
              <i className="hl-list-dollar nav-icon"></i>
              <p>فاکتورها و پیش فاکتورها</p>
            </Link>
          </li>
        </ul>
      </li>
    </>
  );
}

export default FinanceMenu;
